module.exports = __webpack_public_path__ + "img/thumb_30.8e036f96.jpg";